import { render } from "./getBills.vue?vue&type=template&id=73832315&scoped=true"
import script from "./getBills.vue?vue&type=script&lang=js"
export * from "./getBills.vue?vue&type=script&lang=js"

import "./getBills.vue?vue&type=style&index=0&id=73832315&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73832315"]])

export default __exports__